module.exports = __webpack_public_path__ + "media/images/gallery/constellations/vis-c95728914f223caee1b66e11aa05dcb5.jpg";